<template>
  <td class="ind-group-block" v-show="showInner[id]">
    <div class="individual-group-con">
      <!-- When there are inner users -->
      <template v-if="innerUsers.length > 0">
        <div
          class="ind-member-info"
          v-for="user in innerUsers"
          :key="user.id + user.type"
        >
          <group-inner-item :user="user" />
        </div>
      </template>

      <!-- When no inner users -->
      <div class="italic" v-else>
        No permission to view contacts
      </div>
    </div>
  </td>
</template>

<script>
import GroupInnerItem from "./GroupInnerItem";

export default {
  name: "GroupInner",
  props: {
    id: Number, // Id of the group
    innerUsers: Array, // The array of all the inner users
    showInner: Object, // Weather to show inner or not
    updateShowInner: Function // Update show inner
  },
  components: {
    GroupInnerItem
  }
};
</script>

<style scoped>
.italic {
  font-style: italic;
}
</style>
